import { Component, OnInit, ViewEncapsulation, Input } from "@angular/core";
import { CommonBaseComponent } from "../common-base.component";
import {
  MedicalSchool,
  Residency,
  Fellowship
} from "../../../../shared/models/my-account-data.models";
import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl
} from "@angular/forms";
import { AddressComponent } from "../address/address.component";
import { AccountLookupComponent } from "../account-lookup/account-lookup.component";

import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE
} from "@angular/material/core";
import { MatDatepicker } from "@angular/material/datepicker";

// Depending on whether rollup is used, moment needs to be imported differently.
// Since Moment.js doesn't have a default export, we normally need to import using the `* as`
// syntax. However, rollup creates a synthetic default module and we thus need to import it using
// the `default as` syntax.
import * as _moment from "moment";
// tslint:disable-next-line:no-duplicate-imports
import { Moment } from "moment";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { AccountType } from "../../../../shared/enums/data.enums";

const moment = _moment;

// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
export const MY_FORMATS = {
  parse: {
    dateInput: "MM/YYYY"
  },
  display: {
    dateInput: "MM/YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

///declare var moment;

@Component({
  selector: "app-grad-date",
  templateUrl: "./grad-date.component.html",
  styleUrls: ["./grad-date.component.scss"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
	  deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class GradDateComponent extends CommonBaseComponent {
  @Input() graduation: FormGroup;
  minDate = new Date(1900, 1, 1);
  maxDate = new Date(2050, 1, 1);

  get graduationDate() {
    return this.graduation.get("graduationdate");
  }

  @Input() TITLE: string = "Graduation";

  chosenYearHandler(normalizedYear: Moment) {
    let ctrlValue =
      this.graduationDate.valid || this.graduationDate.errors.incorrectDateValue
        ? this.graduationDate.value
        : GradDateComponent.getLastDayOfCurrentMonth();
    // moment(new Date().setDate(1));
    if (ctrlValue) {
      ctrlValue.year(normalizedYear.year());
    } else {
      ctrlValue = normalizedYear;
    }
    this.graduationDate.setValue(ctrlValue);
  }

  chosenMonthHandler(
    normlizedMonth: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    const ctrlValue =
      this.graduationDate.valid || this.graduationDate.errors.incorrectDateValue
        ? this.graduationDate.value
        : GradDateComponent.getLastDayOfCurrentMonth();
    //  moment(new Date().setDate(1));
    ctrlValue.month(normlizedMonth.month());

    this.graduationDate.setValue(ctrlValue);
    //mark as dirty whenever changed
    this.graduation.markAsDirty({ onlySelf: false });
    datepicker.close();
  }

  static buildForm(
    graddate: any,
    fb: FormBuilder,
    inFuture: boolean = null,
    validate: boolean = true
  ) {
    return fb.group({
      graduationdate: [
        graddate == "" ? null : moment(graddate, "MM/DD/YYYY"),

        validate
          ? Validators.compose([
              Validators.required,
              GradDateComponent.ValidateDate(inFuture, "incorrectDateValue")
            ])
          : []
      ]
    });
  }

  static ValidateDate(inFuture: boolean, errorType: string) {
    return function(input: FormControl) {
      let dateValue = input.value;

      let isValid: boolean = false;
      let lastDayOfCurrentMonth = GradDateComponent.getLastDayOfCurrentMonth();

      //input.value._isValid is true when no value is entered yet in the datebox

      if (inFuture == null || !input.value || !input.value._isValid) {
        //no vlaidation
        isValid = true;
      } else {
        if (inFuture) {
          //date should be in future
          isValid = moment(dateValue) >= lastDayOfCurrentMonth;
        } else {
          //date shud NOT be in future
          isValid = moment(dateValue) <= lastDayOfCurrentMonth;
        }
      }

      return isValid ? null : { [errorType]: true };
    };
  }

  static getLastDayOfCurrentMonth() {
    let date = new Date(),
      y = date.getFullYear(),
      m = date.getMonth();
    let firstDay = new Date(y, m, 1);
    let lastDay = new Date(y, m + 1, 0);
    return moment(lastDay);
  }

  static getFirstDayOfCurrentMonth() {
    let date = new Date(),
      y = date.getFullYear(),
      m = date.getMonth();
    let firstDay = new Date(y, m, 1);
    let lastDay = new Date(y, m + 1, 0);
    return moment(firstDay);
  }
}
